module.exports = __webpack_public_path__ + "img/partners-my.0d64061.png";